<template>
  <div class="dk-vl-root">

    <!-- ── Modal: Embed ──────────────────────────────────────── -->
    <el-dialog
      :visible.sync="dialogTableVisible"
      :before-close="handleClose"
      custom-class="dk-embed-dialog"
      width="520px"
    >
      <div class="dk-embed-modal">
        <div class="dk-embed-modal__header">
          <feather-icon icon="CodeIcon" size="20" class="dk-embed-modal__icon" />
          <div>
            <h5 class="dk-embed-modal__title">Código de incorporação</h5>
            <p class="dk-embed-modal__sub">{{ embedCode.name }}</p>
          </div>
        </div>

        <div class="dk-embed-modal__tabs">
          <button class="dk-embed-tab" @click="simples">
            <feather-icon icon="ZapIcon" size="13" class="mr-50" />Simples
          </button>
          <button class="dk-embed-tab" @click="javascript">
            <feather-icon icon="CodeIcon" size="13" class="mr-50" />JS Completo
          </button>
          <button class="dk-embed-tab" @click="iframe">
            <feather-icon icon="FramerIcon" size="13" class="mr-50" />Iframe
          </button>
          <button class="dk-embed-tab" @click="link">
            <feather-icon icon="LinkIcon" size="13" class="mr-50" />Link
          </button>
        </div>

        <div class="dk-embed-modal__code-wrap">
          <textarea id="texto" readonly class="dk-embed-modal__textarea">{{ embedCode.embed }}</textarea>
          <button class="dk-embed-modal__copy-btn" @click="copiarTexto()">
            <feather-icon icon="CopyIcon" size="15" />
          </button>
        </div>

        <div class="dk-embed-modal__footer">
          <button class="dk-embed-modal__close-btn" @click="closeModal">Fechar</button>
        </div>
      </div>
    </el-dialog>

    <!-- ── Modal: Preview de vídeo ───────────────────────────── -->
    <div
      v-if="showModal && !isTrialExpired"
      class="dk-preview-overlay"
      @click="showModal = false"
    >
      <div class="dk-preview-inner" @click.stop>
        <button class="dk-preview-close" @click="showModal = false">
          <feather-icon icon="XIcon" size="20" />
        </button>
        <div class="dk-preview-ratio">
          <iframe
            class="dk-preview-iframe"
            :src="UrlVideo"
            frameborder="0"
            allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
            allowfullscreen
          />
        </div>
      </div>
    </div>

    <!-- ── Trial expired: Player blocked modal ── -->
    <div
      v-if="showModal && isTrialExpired"
      class="dk-preview-overlay"
      @click="showModal = false"
    >
      <div class="dk-trial-player-block" @click.stop>
        <button class="dk-preview-close" @click="showModal = false">
          <feather-icon icon="XIcon" size="20" />
        </button>
        <div class="dk-trial-player-block__inner">
          <div class="dk-trial-player-block__icon">
            <svg width="36" height="36" fill="none" viewBox="0 0 24 24">
              <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="2"/>
              <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <h3 class="dk-trial-player-block__title">Player bloqueado</h3>
          <p class="dk-trial-player-block__text">
            Seu período de teste expirou.<br>
            Faça upgrade para usar o player.
          </p>
          <a :href="kiwifyCheckoutUrl" target="_blank" class="dk-trial-player-block__btn">
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <polyline points="17 8 12 3 7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Fazer Upgrade
          </a>
        </div>
      </div>
    </div>

    <!-- ── Skeleton de carregamento ──────────────────────────── -->
    <div v-if="videosLoading" class="dk-vl-list">
      <div v-for="n in 4" :key="'sk-' + n" class="dk-vc dk-vc--skeleton">
        <div class="dk-vc__check">
          <div class="dk-sk dk-sk--check" />
        </div>
        <div class="dk-vc__thumb dk-sk dk-sk--thumb" />
        <div class="dk-vc__body" style="gap:8px;">
          <div class="dk-sk dk-sk--title" />
          <div class="dk-sk dk-sk--meta" />
        </div>
        <div class="dk-vc__actions" style="gap:10px;">
          <div class="dk-sk dk-sk--btn" />
          <div class="dk-sk dk-sk--btn" />
          <div class="dk-sk dk-sk--btn" />
        </div>
      </div>
    </div>

    <!-- ── Lista de vídeos ────────────────────────────────────── -->
    <div v-else class="dk-vl-list" :class="{ 'dk-vl-grid': viewMode === 'grid' }">
      <div
        v-for="item of vsls"
        :key="item.id"
        class="dk-vc"
        @click="video(item)"
      >
        <!-- Checkbox -->
        <div class="dk-vc__check" @click.stop>
          <label class="dk-vc__check-label">
            <input
              v-model="item.is_selected"
              type="checkbox"
              class="dk-vc__check-input"
              :true-value="true"
              :false-value="false"
              @input="handleChecked(item)"
            >
            <span class="dk-vc__check-box" />
          </label>
        </div>

        <!-- Thumbnail -->
        <div class="dk-vc__thumb" @click.stop="editar(item.id)">
          <img
            :src="item.vsl_frame"
            :alt="item.vsl_name"
            class="dk-vc__thumb-img"
          >
          <div class="dk-vc__thumb-overlay">
            <div class="dk-vc__play-btn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M23.14 10.608L2.253 0.164C1.75 -0.08 1.22 0.015 0.739 0.234C0.328 0.467 0 1.013 0 1.557V22.444C0 23.548 1.198 24.244 2.253 23.836L23.14 13.393C24.205 12.879 24.205 11.122 23.14 10.608Z"/>
              </svg>
            </div>
          </div>
          <span v-if="item.vsl_tempoVideo" class="dk-vc__duration">{{ item.vsl_tempoVideo }}s</span>
        </div>

        <!-- Informações do vídeo -->
        <div class="dk-vc__body" @click="video(item)">
          <!-- Título editável -->
          <div class="dk-vc__title-row" @click.stop>
            <strong :id="'strong' + item.id" class="dk-vc__title" @click="video(item)">
              {{ item.vsl_name }}
            </strong>
            <input
              :id="'input' + item.id"
              v-model="item.vsl_name"
              data-tourTarget="edicaoNomeArquivo"
              class="dk-vc__title-input"
              hidden
              @click.stop
            >
            <button
              :id="'icone-editar' + item.id"
              class="dk-vc__edit-btn"
              @click.stop="aparecerEdição(item.id)"
            >
              <feather-icon icon="Edit3Icon" size="13" />
            </button>
            <button
              :id="'botao-salvar' + item.id"
              class="dk-vc__save-btn"
              hidden
              @click.stop="salvarEdicão(item)"
            >
              <feather-icon icon="CheckIcon" size="13" />
            </button>
          </div>

          <!-- Orientação + data -->
          <div class="dk-vc__meta">
            <span class="dk-vc__orient" :class="item.orientation === 'Vertical' ? 'dk-vc__orient--v' : 'dk-vc__orient--h'">
              <feather-icon :icon="item.orientation === 'Vertical' ? 'SmartphoneIcon' : 'MonitorIcon'" size="11" class="mr-25" />
              {{ item.orientation || 'Horizontal' }}
            </span>
            <span class="dk-vc__date">
              <feather-icon icon="CalendarIcon" size="11" class="mr-25" />
              {{ item.vsl_dt_add }}
            </span>
          </div>
        </div>

        <!-- Ações -->
        <div class="dk-vc__actions" @click.stop>
          <span
            class="dk-vc__views"
            @click="$router.push({ name: 'analytics', params: { vslId: item.id } })"
          >
            <feather-icon icon="EyeIcon" size="12" class="mr-25" />
            {{ item.qtde_load || 0 }}
          </span>

          <button
            v-b-tooltip.hover.top="'Analytics'"
            class="dk-vc__action-btn"
            @click="$router.push({ name: 'analytics', params: { vslId: item.id } })"
          >
            <feather-icon icon="BarChart2Icon" size="15" />
          </button>

          <button
            v-b-tooltip.hover.top="'Embed'"
            class="dk-vc__action-btn"
            @click="embed(item); dialogTableVisible = true"
          >
            <feather-icon icon="CodeIcon" size="15" />
          </button>

          <button
            v-b-tooltip.hover.top="copiedVideoId === item.id ? 'Copiado!' : 'Copiar shortcode'"
            class="dk-vc__action-btn"
            :class="{ 'dk-vc__action-btn--copied': copiedVideoId === item.id }"
            @click="copyShortcode(item)"
          >
            <feather-icon :icon="copiedVideoId === item.id ? 'CheckIcon' : 'CopyIcon'" size="15" />
          </button>

          <span
            v-b-tooltip.hover.top="item.vsl_ativo === 1 || item.vsl_ativo === undefined ? 'Habilitado' : 'Desabilitado'"
            class="dk-vc__toggle"
          >
            <b-form-checkbox
              :checked="item.vsl_ativo === 1 || item.vsl_ativo === undefined"
              class="custom-control-success"
              name="check-button"
              switch
              inline
              @change="toggleVslAtivo(item)"
            />
          </span>

          <el-dropdown @click.stop>
            <button class="dk-vc__action-btn dk-vc__action-btn--more">
              <feather-icon icon="MoreHorizontalIcon" size="15" />
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="editar(item.id)">
                <div class="dk-dd-item">
                  <feather-icon icon="EditIcon" size="14" class="mr-50" />
                  <span>Editar</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item @click.native="embed(item); dialogTableVisible = true">
                <div class="dk-dd-item">
                  <feather-icon icon="CodeIcon" size="14" class="mr-50" />
                  <span>Embed</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item @click.native="$router.push({ name: 'analytics', params: { vslId: item.id } })">
                <div class="dk-dd-item">
                  <feather-icon icon="PieChartIcon" size="14" class="mr-50" />
                  <span>Analytics</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item @click.native="download(item)">
                <div class="dk-dd-item">
                  <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
                  <span>Download</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item divided @click.native="open(item)">
                <div class="dk-dd-item dk-dd-item--danger">
                  <feather-icon icon="TrashIcon" size="14" class="mr-50" />
                  <span>Remover</span>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- Empty state -->
      <div v-if="!videosLoading && vsls.length === 0" class="dk-vl-empty">
        <feather-icon icon="VideoIcon" size="42" class="dk-vl-empty__icon" />
        <p class="dk-vl-empty__text">Nenhum vídeo encontrado</p>
        <p class="dk-vl-empty__sub">Faça upload de um vídeo para começar</p>
      </div>
    </div>
  </div>
</template>
<script>

import axios from 'axios'
import { VslService } from '@/services/Vsl'
import {
  BAlert, BLink, BCard, BCardText, BBadge, BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { useApi, useApiAWS } from '@/composables/useApi'
import EmbedModal from '@/services/embedModal'
import { EventBus } from '@/main'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import trialMixin from '@/mixins/trialMixin'

const apiBack = useApi()
const apiAws = useApiAWS()
export default {
  mixins: [trialMixin],
  components: {
    BBadge,
    BFormCheckbox,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: ['value', 'videosLoading', 'viewMode'],
  data() {
    return {
      copiedVideoId: null,
      teste: {
        id: 0,
        vsl_name: 'teste',
        vsl_description: 'teste-video',
      },
      tableData: [
        {
          id: 0,
          name: 'teste',
          embed: 'teste-video',
        },
        {
          id: 1,
          name: 'teste',
          embed: 'teste-video',
        },
      ],
      UrlVideo: '',
      showModal: false,
      idVsl: {},
      vsl_frame: {},
      dialogTableVisible: false,
      folderVideoChecked: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3 || '/api/dkbucket',
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      vslId: this.$route.params.vslId,
      contentWidth: this.$store.state.appConfig.layout.contentWidth,
      loading: false,
      errorMessage: null,
      embedCode: '',
      embedName: '',
    }
  },
  computed: {
    vsls: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  nome: 'Videos',

  methods: {
    ...mapActions('Videos', ['listarVideos']),
    async toggleVslAtivo(item) {
      const newVal = (item.vsl_ativo === 1 || item.vsl_ativo === undefined) ? 0 : 1
      item.vsl_ativo = newVal
      await apiBack.put(`/updateVslAtivo/${item.id}`, { vsl_ativo: newVal })
        .catch(err => console.error(err))
    },
    updatePrimeiroAcesso() {
      const date = new Date()
      date.setHours(date.getHours() - 3)
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/updatePrimeiroAcesso`, {

        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: this.userData.id,
          user_data_primeiro_acesso: date.toISOString().slice(0, 19).replace('T', ' '),
        }),
      })
        .then(() => {
          const user = JSON.parse(localStorage.getItem('userData'))
          user.user_data_primeiro_acesso = date.toISOString().slice(0, 19).replace('T', ' ')
          localStorage.setItem('userData', JSON.stringify(user))
        })
    },
    copyShortcode(item) {
      const code = `<div>[vid_${item.id}]</div>`
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code)
      } else {
        const ta = document.createElement('textarea')
        ta.value = code
        document.body.appendChild(ta)
        ta.select()
        document.execCommand('copy')
        document.body.removeChild(ta)
      }
      this.copiedVideoId = item.id
      setTimeout(() => { this.copiedVideoId = null }, 3000)
    },
    async closeModal() {
      this.dialogTableVisible = false
      localStorage.removeItem('itemEmbed')
    },
    async simples() {
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal('Codigo Simples')
    },
    async javascript() {
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal('Codigo JS')
    },
    async iframe() {
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal('Codigo Iframe')
    },
    async link() {
      const embedName = 'Link'
      const item = JSON.parse(localStorage.getItem('itemEmbed'))
      let url = item.vsl_bucket_address || item.vsl_url || ''

      url = url
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/ /g, '')

      this.embedCode = {
        name: embedName,
        embed: url,
      }
    },
    handleClose(done) {
      done()
      localStorage.removeItem('itemEmbed')
    },
    playVideo(item) {
      const origin = (window.location.origin || '').replace(/\/$/, '')
      const thumb = item.vsl_frame ? `?thumb=${encodeURIComponent(item.vsl_frame)}` : ''
      this.UrlVideo = `${origin}/api/player-preview/${item.id}${thumb}`
      this.showModal = true
    },
    copiarTexto() {
      const textoCopiado = document.getElementById('texto')
      textoCopiado.select()
      textoCopiado.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.$message({
        message: 'Código copiado para área de transferência',
        type: 'success',
      })
    },
    async embed(item) {
      localStorage.setItem('itemEmbed', JSON.stringify(item))

      // Se o vídeo tem par (videoGroupId), encontra o vídeo de orientação oposta
      // na lista atual para gerar embed responsivo H+V
      let pairedItem = null
      if (item.videoGroupId && this.value && this.value.length) {
        pairedItem = this.value.find(
          v => v.videoGroupId === item.videoGroupId && v.id !== item.id
        ) || null
      }
      localStorage.setItem('itemEmbedPaired', pairedItem ? JSON.stringify(pairedItem) : '')

      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal('Codigo Simples')
    },

    handleChecked(item) {
      this.$emit('selectVideoFolder', item)
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.mp4')
      document.body.appendChild(link)
      link.click()
    },
    download(item) {
      axios({
        method: 'get',
        url: item.vsl_bucket_address,
        responseType: 'arraybuffer',
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('error occured'))
    },

    editar(item) {
      this.$router.push(`/player/${item}`)
    },

    video(item) {
      this.$router.push(`/player/${item.id}`)
      EventBus.$emit('player', this.teste)
    },
    deletarThumb(item) {
      const options = {
        method: 'GET',
        url: `${this.VUE_APP_HOST_API_BACKEND}/tumb_vsl/${item}`,
      }
      axios.request(options).then(response => {
        // Sem thumbs para deletar
        if (!response.data || !Array.isArray(response.data) || !response.data[0]) return

        const row = response.data[0]
        const thumbInicio = row.tumb_key_name_start
        const thumbPausa = row.thumb_key_name_pausa
        const thumbFinal = row.thumb_key_name_end

        if (thumbInicio) {
          axios.request({
            method: 'DELETE',
            url: `${process.env.VUE_APP_HOST_API_AWS_S3 || "/api/dkbucket"}/`,
            params: { key: `${thumbInicio}` },
          }).catch(error => console.error(error))
        }
        if (thumbPausa) {
          axios.request({
            method: 'DELETE',
            url: `${process.env.VUE_APP_HOST_API_AWS_S3 || "/api/dkbucket"}/`,
            params: { key: `${thumbPausa}` },
          }).catch(error => console.error(error))
        }
        if (thumbFinal) {
          axios.request({
            method: 'DELETE',
            url: `${process.env.VUE_APP_HOST_API_AWS_S3 || "/api/dkbucket"}/`,
            params: { key: `${thumbFinal}` },
          }).catch(error => console.error(error))
        }
      }).catch(error => {
        console.error('[deletarThumb]', error)
      })
    },
    deletarFrame(item) {
      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}/`,
        params: { key: `Thumb_frame/thumb_frame-${item}.png` },
      }
      axios.request(options).catch(error => {
        console.error(error)
      })
    },
    async deletarAWS(item) {
      await apiAws.delete('/remover-folder', {
        params: {
          folder_key_name: item,
        },
      })
        .then(resp => {
        })
    },

    deleteVSL(vslId) {
      if (!vslId) {
        console.warn('[deleteVSL] id vazio — pulando deleção no banco')
        this.listarVideos()
        return
      }
      try {
        this.loading = true
        VslService.deleteVsl(vslId)
          .then(response => {
            if (response) { this.listarVideos() }
          })
          .catch(err => {
            console.error('[deleteVSL] erro:', err?.response?.data || err.message)
            this.listarVideos()
          })
      } catch (error) {
        this.errorMessage = error
        this.loading = false
      }
    },
    open(item) {
      const nome = item.vsl_name || 'este vídeo'
      this.$confirm(
        `Tem certeza que deseja excluir "<strong>${nome}</strong>"? Esta ação não pode ser desfeita.`,
        'Excluir vídeo',
        {
          confirmButtonText: 'Sim, excluir',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          confirmButtonClass: 'el-button--danger',
        }
      ).then(() => {
        this.$store.commit('Videos/removeVideoMain', item.id)
        this.deletarAWS(item.vsl_key_name)
        this.deletarFrame(item.id)
        this.deletarThumb(item.id)
        this.deleteVSL(item.id)
        this.$message({
          type: 'success',
          message: `"${nome}" excluído com sucesso.`,
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Exclusão cancelada.',
        })
      })
    },
    aparecerEdição(item) {
      const strong = document.getElementById(`strong${item}`)
      const input = document.getElementById(`input${item}`)
      const botaosalvar = document.getElementById(`botao-salvar${item}`)
      const iconeeditar = document.getElementById(`icone-editar${item}`)
      strong.setAttribute('hidden', '')
      iconeeditar.setAttribute('hidden', '')
      botaosalvar.removeAttribute('hidden')
      input.removeAttribute('hidden')
    },
    salvarEdicão(item) {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: `{"vsl_name":"${item.vsl_name}"}`,
      }

      fetch(`${this.VUE_APP_HOST_API_BACKEND}/updateNameVSL/${item.id}`, options)
        .then(response => response.json())
        .then(response => {
          const strong = document.getElementById(`strong${item.id}`)
          const input = document.getElementById(`input${item.id}`)
          const botaosalvar = document.getElementById(`botao-salvar${item.id}`)
          const iconeeditar = document.getElementById(`icone-editar${item.id}`)
          input.setAttribute('hidden', '')
          botaosalvar.setAttribute('hidden', '')
          iconeeditar.removeAttribute('hidden')
          strong.removeAttribute('hidden')
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
  },

}
</script>
<style lang="scss" scoped>
/* ─── Variáveis DK ───────────────────────────────── */
$navy:   #0D3349;
$orange: #E86A10;
$gold:   #F5B935;
$border: #DDE3EA;
$bg:     #F4F6F9;
$text:   #3D4A5C;
$muted:  #8A98A8;

/* ─── Root ───────────────────────────────────────── */
.dk-vl-root {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ─── Lista de vídeos ────────────────────────────── */
.dk-vl-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}
.dk-vl-grid {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}
.dk-vl-grid .dk-vc {
  flex-direction: column;
  align-items: stretch;
  border-left: none;
  border-radius: 12px;
}
.dk-vl-grid .dk-vc__check { display: none; }
.dk-vl-grid .dk-vc__thumb {
  width: 100%;
  height: 150px;
  border-radius: 10px 10px 0 0;
  margin: 0;
}
.dk-vl-grid .dk-vc__body {
  padding: 12px 14px 8px;
  flex: none;
}
.dk-vl-grid .dk-vc__actions {
  padding: 0 14px 12px;
  justify-content: flex-start;
}
.dk-vl-grid .dk-vc__views {
  margin-right: auto;
}

/* ─── Card do vídeo ──────────────────────────────── */
.dk-vc {
  display: flex;
  align-items: center;
  gap: 0;
  background: linear-gradient(135deg, #fff 0%, #fdfefe 100%);
  border: 1px solid var(--dk-border, #e8edf2);
  border-left: 2px solid rgba($orange, 0.22);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 1px 4px rgba($navy, 0.05);
  overflow: hidden;

  &:hover {
    background: linear-gradient(135deg, #fff 0%, #fff8f4 100%);
    border-color: rgba($orange, 0.28);
    border-left-color: $orange;
    box-shadow: 0 4px 20px rgba($navy, 0.09), 0 0 0 2px rgba($orange, 0.06);
    transform: translateY(-1px);

    .dk-vc__thumb-overlay { opacity: 1; }
    .dk-vc__edit-btn { opacity: 1; }
  }
}

/* ─── Checkbox ───────────────────────────────────── */
.dk-vc__check {
  padding: 0 6px 0 16px;
  flex-shrink: 0;
}
.dk-vc__check-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0;
  position: relative;
}
.dk-vc__check-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;

  &:checked ~ .dk-vc__check-box {
    background: $orange;
    border-color: $orange;

    &::after {
      display: block;
    }
  }
}
.dk-vc__check-box {
  width: 16px;
  height: 16px;
  border: 1.5px solid #c8d4de;
  border-radius: 4px;
  background: var(--dk-bg-card, #fff);
  transition: all 0.15s;
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    display: none;
    position: absolute;
    left: 4px;
    top: 1px;
    width: 5px;
    height: 9px;
    border: 2px solid var(--dk-bg-card, #fff);
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
  }
}

/* ─── Thumbnail ──────────────────────────────────── */
.dk-vc__thumb {
  position: relative;
  width: 156px;
  height: 88px;
  flex-shrink: 0;
  overflow: hidden;
  background: #1a2533;
  margin: 10px 16px 10px 10px;
  border-radius: 8px;
  cursor: pointer;
}
.dk-vc__thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.25s;
}
.dk-vc__thumb:hover .dk-vc__thumb-img {
  transform: scale(1.04);
}
.dk-vc__thumb-overlay {
  position: absolute;
  inset: 0;
  background: rgba($navy, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  border-radius: 8px;
}
.dk-vc__play-btn {
  width: 36px;
  height: 36px;
  background: rgba(255,255,255,0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.3);

  svg { margin-left: 2px; fill: $navy; }
}
.dk-vc__duration {
  position: absolute;
  bottom: 6px;
  right: 7px;
  background: rgba(0,0,0,0.65);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
}

/* ─── Body: título + meta ────────────────────────── */
.dk-vc__body {
  flex: 1;
  min-width: 0;
  padding: 12px 0;
}
.dk-vc__title-row {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: nowrap;
  margin-bottom: 7px;
}
.dk-vc__title {
  font-size: 14px;
  font-weight: 600;
  color: $navy;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 100%;
}
.dk-vc__title-input {
  border: 1.5px solid rgba($orange, 0.4) !important;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 13px;
  color: $navy;
  width: 240px;
  outline: none;
  &:focus { border-color: $orange !important; }
}
.dk-vc__edit-btn {
  background: none;
  border: none;
  padding: 3px;
  border-radius: 5px;
  color: $muted;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s, color 0.15s;
  flex-shrink: 0;
  &:hover { color: $orange; }
}
.dk-vc__save-btn {
  background: none;
  border: none;
  padding: 3px;
  border-radius: 5px;
  color: #22c55e;
  cursor: pointer;
  flex-shrink: 0;
}

.dk-vc__meta {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.dk-vc__orient {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;

  &--h {
    background: rgba(24, 144, 255, 0.08);
    color: #1890ff;
  }
  &--v {
    background: rgba(82, 196, 26, 0.1);
    color: #22a35e;
  }
}
.dk-vc__date {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  color: $muted;
}

/* ─── Ações ──────────────────────────────────────── */
.dk-vc__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px 0 10px;
  flex-shrink: 0;
  border-left: 1px solid rgba($border, 0.7);
  margin-left: 10px;
}
.dk-vc__views {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: $navy !important;
  background: #ffffff !important;
  border-radius: 20px;
  padding: 3px 10px;
  white-space: nowrap;
  margin-right: 4px;
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
  &:hover { color: $navy !important; background: #e8eef4 !important; }
  svg, .feather-icon { color: inherit !important; fill: currentColor !important; }
}
.dk-vc__action-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $bg;
  border: 1px solid $border;
  border-radius: 8px;
  color: $muted;
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover {
    background: $navy;
    color: #fff;
    border-color: $navy;
  }
  &--more:hover {
    background: $bg;
    color: $navy;
    border-color: var(--dk-border, #c0cad4);
  }
  &--copied {
    background: #10B981 !important;
    color: #fff !important;
    border-color: #10B981 !important;
  }
}

.dk-vc__toggle {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  .custom-switch { margin: 0; padding-left: 2.5rem; }
}

/* ─── Dropdown items ─────────────────────────────── */
.dk-dd-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: $text;
  &--danger { color: #c12b2b; }
}

/* ─── Empty state ────────────────────────────────── */
.dk-vl-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 24px;
  background: var(--dk-bg-card, #fff);
  border: 1px dashed $border;
  border-radius: 14px;
  text-align: center;
  margin-top: 8px;
}

@media (max-width: 860px) {
  .dk-vc {
    flex-direction: column;
    align-items: stretch;
  }
  .dk-vc__check {
    padding: 10px 12px 0;
  }
  .dk-vc__thumb {
    width: auto;
    height: 172px;
    margin: 8px 12px 0;
  }
  .dk-vc__body {
    padding: 12px;
  }
  .dk-vc__actions {
    padding: 0 12px 12px;
    border-left: none;
    margin-left: 0;
  }
}
.dk-vl-empty__icon { color: var(--dk-text-faint, #c8d0da); margin-bottom: 14px; }
.dk-vl-empty__text { font-size: 15px; font-weight: 600; color: $navy; margin: 0; }
.dk-vl-empty__sub  { font-size: 13px; color: $muted; margin: 4px 0 0; }

/* ─── Modal: Embed ───────────────────────────────── */
.dk-embed-modal {
  padding: 0;
}
.dk-embed-modal__header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid $border;
}
.dk-embed-modal__icon { color: $orange; flex-shrink: 0; }
.dk-embed-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: $navy;
  margin: 0;
}
.dk-embed-modal__sub {
  font-size: 12px;
  color: $muted;
  margin: 2px 0 0;
}
.dk-embed-modal__tabs {
  display: flex;
  gap: 6px;
  padding: 14px 22px;
}
.dk-embed-tab {
  display: inline-flex;
  align-items: center;
  background: #e5e7eb;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #1f2937 !important;
  opacity: 1 !important;
  cursor: pointer;
  transition: all 0.15s;
  text-shadow: none;

  svg {
    color: currentColor;
  }

  &:focus,
  &:active,
  &:visited {
    color: #1f2937 !important;
  }

  &:hover {
    background: $navy;
    color: #fff;
    border-color: $navy;
  }
}
.dk-embed-modal__code-wrap {
  position: relative;
  padding: 0 22px;
  margin-bottom: 14px;
}
.dk-embed-modal__textarea {
  width: 100%;
  height: 140px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 12px 40px 12px 12px;
  font-family: monospace;
  font-size: 12px;
  color: $text;
  background: $bg;
  resize: none;
  outline: none;
}
.dk-embed-modal__copy-btn {
  position: absolute;
  top: 8px;
  right: 30px;
  background: $navy;
  border: none;
  border-radius: 6px;
  padding: 5px 7px;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: darken(#0D3349, 6%); }
}
.dk-embed-modal__footer {
  display: flex;
  justify-content: flex-end;
  padding: 0 22px 20px;
}
.dk-embed-modal__close-btn {
  background: $bg;
  border: 1px solid $border;
  border-radius: 8px;
  padding: 8px 22px;
  font-size: 13px;
  font-weight: 600;
  color: $text;
  cursor: pointer;
  &:hover { background: #e2e6ea; }
}

/* ─── Modal: Preview de vídeo ────────────────────── */
.dk-preview-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0,0,0,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.dk-preview-inner {
  position: relative;
  width: 100%;
  max-width: 900px;
}
.dk-preview-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  opacity: 0.8;
  &:hover { opacity: 1; }
}
.dk-preview-ratio {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}
.dk-preview-iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 10px;
}

/* ─── ElDialog override ──────────────────────────── */
::v-deep .dk-embed-dialog {
  border-radius: 14px;
  overflow: hidden;

  .el-dialog__header { display: none; }
  .el-dialog__body { padding: 0; }
}

/* ─── Skeleton loader ────────────────────────────── */
@keyframes dk-shimmer {
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
}
@keyframes dk-pulse {
  0%, 100% { opacity: 0.4; }
  50%      { opacity: 0.8; }
}

.dk-sk {
  background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%);
  background-size: 1200px 100%;
  animation: dk-shimmer 1.8s infinite linear;
  border-radius: 6px;
}

.dk-sk--check  { width: 16px; height: 16px; border-radius: 4px; }
.dk-sk--thumb  { width: 80px; height: 52px; border-radius: 10px; flex-shrink: 0; }
.dk-sk--title  { height: 12px; width: 55%; border-radius: 6px; }
.dk-sk--meta   { height: 10px; width: 35%; border-radius: 6px; }
.dk-sk--btn    { width: 28px; height: 28px; border-radius: 8px; }

.dk-vc--skeleton {
  pointer-events: none;
  cursor: default;
  border-color: #e2e8f0 !important;
  background: #f8fafc !important;
}

// ── Trial expired: Player blocked modal ──────────────
.dk-trial-player-block {
  position: relative;
  background: #fff;
  border-radius: 18px;
  padding: 0;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.dk-trial-player-block__inner {
  text-align: center;
  padding: 48px 36px 40px;
}

.dk-trial-player-block__icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba($orange, 0.12), rgba($gold, 0.08));
  color: $orange;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.dk-trial-player-block__title {
  font-size: 1.2rem;
  font-weight: 800;
  color: $navy;
  margin: 0 0 10px;
}

.dk-trial-player-block__text {
  font-size: 0.85rem;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 24px;
}

.dk-trial-player-block__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  background: linear-gradient(135deg, $orange, #f08535);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.15s;
  box-shadow: 0 4px 14px rgba($orange, 0.35);

  &:hover {
    background: linear-gradient(135deg, darken($orange, 8%), $orange);
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba($orange, 0.45);
    color: #fff;
  }
}
</style>

<style lang="scss">
/* ── Dark mode overrides for video list (unscoped) ── */
.dark-layout {
  .dk-embed-tab {
    background: #1f2937 !important;
    border-color: rgba(255,255,255,0.18) !important;
    color: #f8fafc !important;
    opacity: 1 !important;

    &:focus,
    &:active,
    &:visited {
      color: #f8fafc !important;
    }

    &:hover {
      background: #E86A10 !important;
      color: #fff !important;
      border-color: #E86A10 !important;
    }
  }

  .dk-vc {
    background: linear-gradient(135deg, #1e2d3d 0%, #162234 100%) !important;
    border-color: rgba(255,255,255,0.06) !important;
    border-left-color: rgba(232,106,16,0.35) !important;
    box-shadow: 0 1px 4px rgba(0,0,0,0.25) !important;

    &:hover {
      background: linear-gradient(135deg, #223344 0%, #1a2c3c 100%) !important;
      border-left-color: #E86A10 !important;
    }
  }

  .dk-vc__title {
    color: #e2e8f0 !important;
  }

  .dk-vc__title-input {
    background: rgba(255,255,255,0.07) !important;
    color: #e2e8f0 !important;
    border-color: rgba(232,106,16,0.4) !important;
  }

  .dk-vc__date {
    color: rgba(255,255,255,0.45) !important;
  }

  .dk-vc__orient--h {
    background: rgba(96,165,250,0.1) !important;
    color: #60a5fa !important;
  }
  .dk-vc__orient--v {
    background: rgba(74,222,128,0.1) !important;
    color: #4ade80 !important;
  }

  .dk-vc__views {
    background: rgba(0,0,0,0.08) !important;
    color: #fff !important;
    border: 1px solid rgba(255,255,255,0.06) !important;
    svg, .feather-icon { color: inherit !important; fill: currentColor !important; }
    &:hover {
      background: rgba(255,255,255,0.12) !important;
      color: #111 !important;
    }
  }

  .dk-vc__action-btn {
    background: rgba(255,255,255,0.06) !important;
    border-color: rgba(255,255,255,0.09) !important;
    color: rgba(255,255,255,0.55) !important;
    &:hover {
      background: #E86A10 !important;
      color: #fff !important;
      border-color: #E86A10 !important;
    }
    &.dk-vc__action-btn--more:hover {
      background: rgba(255,255,255,0.1) !important;
      color: #e2e8f0 !important;
      border-color: rgba(255,255,255,0.15) !important;
    }
    &.dk-vc__action-btn--copied {
      background: #10B981 !important;
      color: #fff !important;
      border-color: #10B981 !important;
    }
  }

  .dk-vc__check-box {
    background: rgba(255,255,255,0.07) !important;
    border-color: rgba(255,255,255,0.2) !important;
  }

  .dk-vc__actions {
    border-left-color: rgba(255,255,255,0.07) !important;
  }

  .dk-vc__edit-btn {
    color: rgba(255,255,255,0.35) !important;
  }

  .dk-vl-empty {
    background: rgba(255,255,255,0.03) !important;
    border-color: rgba(255,255,255,0.08) !important;
  }
  .dk-vl-empty__text { color: #e2e8f0 !important; }
  .dk-vl-empty__sub  { color: rgba(255,255,255,0.45) !important; }

  .dk-sk {
    background: linear-gradient(90deg, #1e2d3d 25%, #263545 50%, #1e2d3d 75%) !important;
    background-size: 1200px 100% !important;
  }
  .dk-vc--skeleton {
    background: #1e2d3d !important;
    border-color: rgba(255,255,255,0.05) !important;
  }
}
</style>
